package gr.tech.pdfgenerator.components.generation

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.autoLength
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.pdfgenerator.infrastructure.calculations.toPercentage
import gr.tech.pdfgenerator.models.TierThreeEquipmentDTO
import gr.tech.pdfgenerator.styles.BoldItalic
import gr.tech.pdfgenerator.styles.BoldUnderline
import gr.tech.pdfgenerator.styles.GeneralDocumentDividerStyle
import gr.tech.pdfgenerator.styles.GeneralParagraphStyle
import gr.tech.pdfgenerator.styles.SmallerItemParagraphStyle
import gr.tech.pdfgenerator.styles.insertedFieldStyle
import gr.tech.pdfgenerator.styles.pageStyleLeftRightPadding
import gr.tech.pdfgenerator.styles.pdfTableColumnStyle
import gr.tech.pdfgenerator.styles.pdfTableTextStyle
import gr.tech.pdfgenerator.styles.t3DocumentTitleFontStyle
import gr.tech.pdfgenerator.styles.t3HeaderBackground
import gr.tech.pdfgenerator.styles.t3SignBelowListItemStyle
import gr.tech.pdfgenerator.styles.t3SignBoxStyle
import gr.tech.pdfgenerator.styles.t3TableColumnStyle
import gr.tech.pdfgenerator.styles.t3TableHeaderColumnStyle
import gr.tech.pdfgenerator.styles.t3TableHeaderStyle
import gr.tech.pdfgenerator.styles.t3FeeTableTextStyle
import gr.tech.pdfgenerator.styles.t3QEESMTableTextStyle
import gr.tech.pdfgenerator.util.RES
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Table
import org.jetbrains.compose.web.dom.Td
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Th
import org.jetbrains.compose.web.dom.Tr


@Composable
fun t3DocumentHeader() {
    Column(Modifier.fillMaxWidth().padding(leftRight = 32.px)) {
        Row(Modifier.fillMaxWidth()) {
            H3(t3DocumentTitleFontStyle.toAttrs()) { Text("Green Rebates, L.L.C - Rebate Procurement Agreement") }
            Spacer()
            H3(t3DocumentTitleFontStyle.toAttrs()) { Text(RES.TIER_THREE.DOCUMENT_YEAR) }
        }
        HorizontalDivider(GeneralDocumentDividerStyle.toModifier().pageStyleLeftRightPadding())
    }
}

@Composable
fun t3DocumentFooter(currPage: Int, maxPages: Int) {
    Column(Modifier.fillMaxWidth().padding(leftRight = 32.px)) {
        HorizontalDivider(GeneralDocumentDividerStyle.toModifier().pageStyleLeftRightPadding())
        Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.End) {
            H3(t3DocumentTitleFontStyle.toAttrs()) { Text("Page $currPage of $maxPages") }
        }
    }
}

@Composable
fun t3SignBelowBoxes(
    textContent: @Composable () -> Unit
) {
    Li(t3SignBelowListItemStyle.toAttrs()) {
        Div(t3SignBoxStyle.toAttrs())

        textContent()
    }
}

@Composable
fun t3FeeTable(
    lightingPercentage: Double,
    dehumidifierPercentage: Double,
    heatCurtainsPercentage: Double,
    hvacPercentage: Double
) {
    Table(
        attrs = Modifier.fillMaxWidth().border(1.px, LineStyle.Solid, Colors.Black)
            .toAttrs {}
    ) {
        Tr(
            attrs = Modifier.border(0.5.px, LineStyle.Solid, Colors.Black).height(20.px).toAttrs()
        ) {
            Th(
                t3TableColumnStyle.toModifier().then(t3HeaderBackground.toModifier())
                    .width(70.percent).toAttrs()
            ) {
                P(t3FeeTableTextStyle.toAttrs()) { Text("Equipment Type") }
            }
            Th(
                t3TableColumnStyle.toModifier().then(t3HeaderBackground.toModifier())
                    .width(30.percent).toAttrs()
            ) {
                P(t3FeeTableTextStyle.toAttrs()) { Text("Fee") }
            }
        }
        Tr(Modifier.border(0.5.px, LineStyle.Solid, Colors.Black).height(35.px).toAttrs()) {
            Td(t3TableColumnStyle.toModifier().width(15.percent).toAttrs()) {
                P(t3FeeTableTextStyle.toAttrs()) { Text("Lighting") }
            }
            Td(t3TableColumnStyle.toModifier().width(50.percent).toAttrs()) {
                P(t3FeeTableTextStyle.toAttrs()) { Text(lightingPercentage.toPercentage()) }
            }
        }
        Tr(Modifier.border(0.5.px, LineStyle.Solid, Colors.Black).height(35.px).toAttrs()) {
            Td(t3TableColumnStyle.toModifier().width(15.percent).toAttrs()) {
                P(t3FeeTableTextStyle.toAttrs()) { Text("Dehumidifiers") }
            }
            Td(t3TableColumnStyle.toModifier().width(50.percent).toAttrs()) {
                P(t3FeeTableTextStyle.toAttrs()) { Text(dehumidifierPercentage.toPercentage()) }
            }
        }
        Tr(Modifier.border(0.5.px, LineStyle.Solid, Colors.Black).height(35.px).toAttrs()) {
            Td(t3TableColumnStyle.toModifier().width(15.percent).toAttrs()) {
                P(t3FeeTableTextStyle.toAttrs()) { Text("Heat Curtains") }
            }
            Td(t3TableColumnStyle.toModifier().width(50.percent).toAttrs()) {
                P(t3FeeTableTextStyle.toAttrs()) { Text(heatCurtainsPercentage.toPercentage()) }
            }
        }
        Tr(Modifier.border(0.5.px, LineStyle.Solid, Colors.Black).height(35.px).toAttrs()) {
            Td(t3TableColumnStyle.toModifier().width(15.percent).toAttrs()) {
                P(t3FeeTableTextStyle.toAttrs()) { Text("HVAC") }
            }
            Td(t3TableColumnStyle.toModifier().width(50.percent).toAttrs()) {
                P(t3FeeTableTextStyle.toAttrs()) { Text(hvacPercentage.toPercentage()) }
            }
        }
    }
}

@Composable
fun t3QEESMTable(equipmentList: List<TierThreeEquipmentDTO>) {

    @Composable
    fun blankQEESMRow() {
        Tr(Modifier.border(1.px, LineStyle.Solid, Colors.Black).height(35.px).toAttrs()) {
            Td(t3TableColumnStyle.toModifier().toAttrs()) {
                P(t3FeeTableTextStyle.toAttrs()) { Text("") }
            }
            Td(pdfTableColumnStyle.toModifier().toAttrs()) {
                P(t3QEESMTableTextStyle.toAttrs()) { Text("") }
            }
            Td(pdfTableColumnStyle.toModifier().toAttrs()) {
                P(t3QEESMTableTextStyle.toAttrs()) { Text("") }
            }
        }
    }

    Table(
        attrs = Modifier.fillMaxWidth().border(1.px, LineStyle.Solid, Colors.Black)
            .toAttrs {}
    ) {
        Tr(
            attrs = Modifier.border(1.px, LineStyle.Solid, Colors.Black).height(20.px).toAttrs()
        ) {
            Th(
                t3TableHeaderColumnStyle.toModifier().then(t3HeaderBackground.toModifier())
                    .width(15.percent).toAttrs()
            ) {
                P(t3TableHeaderStyle.toAttrs()) { Text("Project Phase") }
            }
            Th(
                t3TableHeaderColumnStyle.toModifier().then(t3HeaderBackground.toModifier())
                    .width(35.percent).toAttrs()
            ) {
                P(t3TableHeaderStyle.toAttrs()) { Text("Equipment") }
            }
            Th(
                t3TableHeaderColumnStyle.toModifier().then(t3HeaderBackground.toModifier())
                    .width(50.percent).toAttrs()
            ) {
                P(t3TableHeaderStyle.toModifier().toAttrs()) { Text("Phase Notes") }
            }
        }

        equipmentList.forEachIndexed { index, equipment ->
            Tr(Modifier.border(1.px, LineStyle.Solid, Colors.Black).height(35.px).toAttrs()) {
                Td(t3TableColumnStyle.toModifier().padding(6.px).toAttrs()) {
                    P(t3FeeTableTextStyle.toModifier().textAlign(TextAlign.Center).toAttrs()) { Text(equipment.phase) }
                }
                Td(pdfTableColumnStyle.toModifier().toAttrs()) {
                    P(t3QEESMTableTextStyle.toAttrs()) { Text(equipment.equipment) }
                }
                Td(pdfTableColumnStyle.toModifier().toAttrs()) {
                    P(t3QEESMTableTextStyle.toAttrs()) { Text(equipment.notes) }
                }
            }
        }

        repeat(4 - equipmentList.size) {
            blankQEESMRow()
        }

    }
}

@Composable
fun t3DisplayPDFDeliverables(deliverableRow: TierThreeEquipmentDTO) {
    Tr(Modifier.border(1.px, LineStyle.Solid, Colors.Black).height(35.px).toAttrs()) {
        Td(pdfTableColumnStyle.toModifier().width(15.percent).toAttrs()) {
            P(pdfTableTextStyle.toAttrs()) { Text(deliverableRow.phase) }
        }
        Td(pdfTableColumnStyle.toModifier().width(50.percent).toAttrs()) {
            P(pdfTableTextStyle.toAttrs()) { Text(deliverableRow.equipment) }
        }
        Td(pdfTableColumnStyle.toModifier().textAlign(TextAlign.Start).width(35.percent).toAttrs()) {
            P(pdfTableTextStyle.toAttrs()) { Text(deliverableRow.notes) }
        }
    }
}

@Composable
fun t3SignatureRow(label: String, signedValue: String? = null) {
    Row(
        modifier = Modifier.fillMaxSize().margin(top = 16.px).gap(8.px),
        horizontalArrangement = Arrangement.Start
    ) {
        Column(modifier = Modifier.width(20.percent)) {
            SpanText(label, GeneralParagraphStyle.toModifier())
        }

        Column(modifier = Modifier.fillMaxHeight()
        ) {
            SpanText(
                text = signedValue ?: " ",
                modifier = GeneralParagraphStyle.toModifier()
                    .width(if (signedValue != null) 100.percent else 200.px)
                    .borderBottom(
                        1.px,
                        LineStyle.Solid,
                        if (signedValue != null) Colors.Transparent else Colors.Black)
            )
        }
    }
}


/*
    All old functions from the old generate page
 */

@Composable
fun t3IntroParagraph(
    accountName: String,
    companyState: String,
    companyAddress: String,
    companyCity: String,
    companyZip: String,
    effectiveDate: String,
) {
    Div(insertedFieldStyle
        .toModifier()
        .width(623.px)
        .top(75.px)
        .left(96.px)
        .margin(leftRight = autoLength)
        .toAttrs()
    ) {
        P(GeneralParagraphStyle
            .toModifier()
            .toAttrs()
        ) {
            Text("THIS REBATE PROCUREMENT AGREEMENT (the \"")
            SpanText("Agreement", Modifier.fontWeight(FontWeight.Bolder).fontStyle(FontStyle.Italic))
            Text("\") is entered into as of ")
            SpanText(effectiveDate, Modifier.textDecorationLine(TextDecorationLine.Underline))
            Text(" (the \"")
            SpanText("Effective Date", Modifier.fontWeight(FontWeight.Bolder).fontStyle(FontStyle.Italic))
            Text("\"), by and between ")
            SpanText("GREEN REBATES, L.L.C", Modifier.textDecorationLine(TextDecorationLine.Underline))
            Text(", a State of Delaware limited liability company with its principal place of business located at ")
            SpanText("11753 Lakeside Ave NE Seattle, WA, 98125", Modifier.textDecorationLine(TextDecorationLine.Underline))
            Text(" (hereinafter \"")
            SpanText("Company", Modifier.fontWeight(FontWeight.Bolder).fontStyle(FontStyle.Italic))
            Text("\"); and ")
            SpanText(accountName, Modifier.textDecorationLine(TextDecorationLine.Underline))
            Text(", a company of the State of ")
            SpanText(companyState, Modifier.textDecorationLine(TextDecorationLine.Underline))
            Text(" with a principal place of business located at ")
            SpanText("$companyAddress, $companyCity $companyState $companyZip", Modifier.textDecorationLine(TextDecorationLine.Underline))
            SpanText(" (\" Customer", Modifier.fontWeight(FontWeight.Bolder).fontStyle(FontStyle.Italic))
            Text("\")(collectively hereinafter ")
            SpanText("Company", Modifier.fontWeight(FontWeight.Bolder).fontStyle(FontStyle.Italic))
            Text(" and ")
            SpanText("Customer", Modifier.fontWeight(FontWeight.Bolder).fontStyle(FontStyle.Italic))
            Text(" referred to as the, \"")
            SpanText("Parties", Modifier.fontWeight(FontWeight.Bolder).fontStyle(FontStyle.Italic))
            Text("\").")
        }
    }
}

@Composable
fun t3ScopeWorkParagraph(
    companyUtility: String
) {
    Div(insertedFieldStyle
        .toModifier()
        .width(600.px)
        .top(240.px)
        .left(120.px)
        .margin(leftRight = autoLength)
        .toAttrs()
    ) {
        P(SmallerItemParagraphStyle
            .toModifier()
            .toAttrs()
        ) {
            SpanText("Scope of Work; General", BoldUnderline.toModifier())
            Text(" By Signing this Agreement,")
            SpanText(" Customer", BoldItalic.toModifier())
            Text(" hereby authorizes")
            SpanText(" Company", BoldItalic.toModifier())
            Text(" to procure on the")
            SpanText(" Customer's", BoldItalic.toModifier())
            Text(" behalf with the")
            SpanText(" Customer's", BoldItalic.toModifier())
            Text(" electricity provider, ")
            SpanText("$companyUtility", Modifier.textDecorationLine(TextDecorationLine.Underline))
            SpanText(" (\"Service Provider\")", BoldItalic.toModifier())
            Text(", the rebates and incentives in relation to qualifying electric energy saving equipment, as outlined in the attached")
            Text(" Exhibit A (the \"")
            SpanText("Equipment", BoldItalic.toModifier())
            Text("\"), being offered by the")
            SpanText("Service Provider.", BoldItalic.toModifier())
            Text(" As authorized agent-in-fact,")
            SpanText(" Company", BoldItalic.toModifier())
            Text(" will prepare and submit all necessary forms and documents to")
            SpanText(" Service Provider", BoldItalic.toModifier())
            Text(" for rebate approval.")
            SpanText(" Company", BoldItalic.toModifier())
            Text(" will work with")
            SpanText(" Customer", BoldItalic.toModifier())
            Text(" to ensure the implementation of the")
            SpanText(" Equipment", BoldItalic.toModifier())
            Text(" required for the approved incentive rebate. It is the sole responsibility of the")
            SpanText(" Customer", BoldItalic.toModifier())
            Text(" to install all")
            SpanText(" Equipment", BoldItalic.toModifier())
            Text(" in a timely manner.")
        }
    }
}

@Composable
fun t3ToCustomerLine(
    accountName: String,
    companyAddress: String,
    companyCity: String,
    companyState: String,
    companyZip: String
) {
    Div(
        insertedFieldStyle.toModifier()
            .then(SmallerItemParagraphStyle.toModifier())
            .width(430.px)
            .top(433.px)
            .left(96.px)
            .margin(leftRight = autoLength)
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .toAttrs()
    ) {
        SpanText(accountName)
        SpanText(companyAddress,)
        SpanText("$companyCity, $companyState $companyZip",)
    }
}

@Composable
fun t3RepresentativeName(
    grRepName: String,
    grRepTitle: String
) {
    Div(
        insertedFieldStyle.toModifier()
            .then(SmallerItemParagraphStyle.toModifier())
            .width(430.px)
            .top(899.px)
            .left(433.px)
            .gap(14.px)
            .margin(leftRight = autoLength)
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .toAttrs()
    ) {
        SpanText(grRepName)
        SpanText(grRepTitle)
    }
}

